import { isObject } from './isObject.js';

const cloneValue = (value) => {
  if (Array.isArray(value)) {
    return [...value];
  }

  if (!isObject(value)) {
    return value;
  }

  const next = {};

  for (const [key, nestedValue] of Object.entries(value)) {
    next[key] = cloneValue(nestedValue);
  }

  return next;
};

export const mergeDeepMissing = (preferredValue = {}, fallbackValue = {}) => {
  const preferred = isObject(preferredValue) ? preferredValue : {};
  const fallback = isObject(fallbackValue) ? fallbackValue : {};
  const next = {
    ...preferred
  };

  for (const [key, fallbackChild] of Object.entries(fallback)) {
    if (!Object.prototype.hasOwnProperty.call(preferred, key)) {
      next[key] = cloneValue(fallbackChild);
      continue;
    }

    const preferredChild = preferred[key];

    if (isObject(preferredChild) && isObject(fallbackChild)) {
      next[key] = mergeDeepMissing(preferredChild, fallbackChild);
    }
  }

  return next;
};
